<mat-card appearance="outlined" class="col-12 stretch">
  <mat-card-header> System Usage </mat-card-header>
  <mat-card-content class="row">
    <div class="col-12">
      <button mat-button color="primary" (click)="navToReporting()">
        Review Session Level Usage
      </button>
    </div>

    @if (!selectedUnit) {
      <div>Please Select a Unit to to See Data.</div>
    }

    @if (viewMode === 'chart' && selectedUnit) {
      <div class="chart-container mt-2 w-100">
        @if (!noData) {
          @if (loading) {
            <div class="no-chart-data"> Loading Data </div>
          } @else {
            <highcharts-chart
              [Highcharts]="Highcharts"
              [options]="chart.data"
            ></highcharts-chart>
          }
        } @else {
          <div class="no-chart-data">
            No data for selected filters
            @if (noDataMessage === 'insufficient') {
              <span>
                Please select dates spanning multiple months of data to be able
                to see a trend.
              </span>
            } @else if (noDataMessage === 'noData') {
              <span>
                There is no data for this unit in the selected date range.
              </span>
            }
          </div>
        }
        <div class="chart-legend">
          @if (chart.legend) {
            <table>
              <thead>
                <tr>
                  @for (th of chart.legend.header; track th) {
                    @if (th.toLowerCase() !== 'color') {
                      <th>
                        {{ th.replace('_', ' ') }}
                      </th>
                    }
                  }
                </tr>
              </thead>
              <tbody>
                @for (tr of chart.legend.data; track tr) {
                  <tr>
                    @for (key of chart.legend.header; track key) {
                      <td>
                        {{ tr[key] }}
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      </div>
    }
    <div
      class="col-12 data-container mt-3"
      [hidden]="viewMode === 'chart' && selectedUnit"
    >
      @if (data) {
        <kendo-grid
          class="w-100 case-stats-activity-grid"
          #usageGrid="kendoGrid"
          [kendoGridBinding]="data.data"
          [style.maxHeight.px]="350"
          [navigable]="true"
        >
          @for (col of data.header; track col.DataField) {
            <kendo-grid-column
              [field]="col.DataField"
              [title]="col.Label"
              [width]="250"
            ></kendo-grid-column>
          }
          <kendo-grid-excel fileName="system-usage.xlsx"></kendo-grid-excel>
        </kendo-grid>
      }
    </div>
  </mat-card-content>
  <ngx-loading
    [show]="loading"
    [config]="{ fullScreenBackdrop: false }"
  ></ngx-loading>
</mat-card>
